import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/28d4b32fb3d88da762020195673dc318.jpg"
          alt="Magazine printing press"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="text-[#F0EAD6] text-xs tracking-[0.3em] uppercase font-semibold mb-5">Your audience is waiting.</p>
        <h2 className="text-4xl md:text-6xl font-serif font-light text-white leading-tight mb-6">
          Your Content Deserves<br />to Be <em className="italic">Held</em>
        </h2>
        <p className="text-white/70 text-lg font-light max-w-2xl mx-auto mb-10 leading-relaxed">
          In a digital world, make something real. Create something memorable. Give them access to your content, unplugged. Your magazine could be in people&apos;s hands in a matter of weeks.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/apply"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#C41E3A] text-white text-sm font-semibold tracking-wide whitespace-nowrap hover:bg-[#A0182E] transition-colors cursor-pointer"
          >
            Start Your Magazine
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/30 text-white text-sm font-semibold tracking-wide whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
          >
            Learn More About Us
          </Link>
        </div>
      </div>
    </section>
  );
}
